import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { EuiLoadingContent } from '@elastic/eui'

import { useGetAccountsQuery } from 'api/rtkQueryApi/platform/accountsApi'
import { useGetAIPlanQuery } from 'api/rtkQueryApi/platform/aiPlansApi'
import { showSuccessToast, updateAccountState } from 'app/appSlice'
import { RootState } from 'app/rootReducer'
import { useIsAgency } from 'whiteLabel/useIsAgency'

import AIPlanPage from './AIPlanPage'

interface AIPlanPageParams {
  aiPlanId: string
}

const AIPlanPageDynamic: FC = () => {
  const dispatch = useDispatch()
  const isAgency = useIsAgency()
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const { aiPlanId } = useParams<AIPlanPageParams>()

  const { data: accounts } = useGetAccountsQuery({ isAgency })
  const { data: aiPlan, isFetching, isLoading } = useGetAIPlanQuery({ aiPlanId }, { skip: !aiPlanId })

  useEffect(() => {
    if (!aiPlan || !currentAccount || !accounts) {
      return
    }

    if (aiPlan.accountId !== currentAccount.id) {
      const account = accounts.find(a => a.id === aiPlan.accountId)
      if (account) {
        dispatch(updateAccountState(account))
        dispatch(showSuccessToast(`Switched account to ${account.name}`))
      }
    }
  }, [aiPlan, currentAccount, accounts])

  if (isLoading || (!aiPlan && isFetching)) {
    return <EuiLoadingContent lines={10} />
  }

  if (!currentAccount || !aiPlan || currentAccount.id !== aiPlan.accountId) {
    return <EuiLoadingContent lines={10} />
  }

  return <AIPlanPage />
}

export default AIPlanPageDynamic
